import { render, staticRenderFns } from "./saoma2.vue?vue&type=template&id=9f9786fe&scoped=true"
import script from "./saoma2.vue?vue&type=script&lang=js"
export * from "./saoma2.vue?vue&type=script&lang=js"
import style0 from "./saoma2.vue?vue&type=style&index=0&id=9f9786fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9786fe",
  null
  
)

export default component.exports